import type { Column } from '@talos/kyoko';
import type { ColDef } from 'ag-grid-community';
import { PriceGridMarketStatusIndicator } from '../hooks/actions/marketStatus/PriceGridMarketStatusIndicator';
import type { PriceGridEntity } from '../PriceGridEntity';
import { PriceGridMarketStatusIndicatorCell } from '../variants/GenericPriceGrid/styles';
import { PRICE_GRID_MARKET_DATA_COLUMN_TYPE } from './constants';
import {
  getPriceGridMarketDataColumnId,
  getSymbolFromRow,
  PRICE_GRID_MARKET_DATA_LEAF_COLUMN_PROPS,
  PRICE_GRID_MARKET_DATA_MARKET_STATUS_COLUMN_SUFFIX,
  type PriceGridMarketDataColumnRow,
  type PriceGridMarketDataRendererParams,
} from './priceGridMarketDataColumnUtils';
import type { PriceGridSecurityMarketDataColumnParams } from './types';

const PRICE_GRID_MARKET_STATUS_COLUMN_INITIAL_WIDTH = 24;

export function getPriceGridMarketStatusColumn(
  column: Column<PriceGridSecurityMarketDataColumnParams, PriceGridMarketDataColumnRow>
): Column<ColDef<PriceGridEntity, PriceGridEntity>, PriceGridMarketDataColumnRow> {
  const colId = getPriceGridMarketDataColumnId(column, PRICE_GRID_MARKET_DATA_MARKET_STATUS_COLUMN_SUFFIX);

  return {
    type: 'custom',
    id: colId,
    field: column.field,
    title: '',
    initialWidth: PRICE_GRID_MARKET_STATUS_COLUMN_INITIAL_WIDTH,
    minWidth: PRICE_GRID_MARKET_STATUS_COLUMN_INITIAL_WIDTH,
    maxWidth: PRICE_GRID_MARKET_STATUS_COLUMN_INITIAL_WIDTH,
    sortable: false,
    ...PRICE_GRID_MARKET_DATA_LEAF_COLUMN_PROPS,
    params: {
      colId,
      headerName: '',
      resizable: false,
      cellRendererParams: {
        priceGridMarketDataColumnType: PRICE_GRID_MARKET_DATA_COLUMN_TYPE,
        priceGridMarketDataColumnParams: column.params,
      },
      valueGetter: ({ data }) => data,
      cellRenderer: (params: PriceGridMarketDataRendererParams) => {
        const row = params.value;
        const symbol = row ? getSymbolFromRow(column, row) : undefined;
        if (!row || !symbol) {
          return null;
        }
        const colDef = { ...params.colDef, dynamics: column.dynamics };

        return (
          <PriceGridMarketStatusIndicatorCell>
            {row.isParentRow ? <PriceGridMarketStatusIndicator params={{ ...params, colDef, data: row }} /> : null}
          </PriceGridMarketStatusIndicatorCell>
        );
      },
    },
  };
}
